import styled from "styled-components/macro";
import {
  brandPrimary70,
  darkBlue,
  darkModeTextColor,
  darkModeTitleBackgroundColor,
  darkNeutral10,
  lightBlueActive,
  lightTextBody,
} from "../../../constants/colors";
import {
  BREAKPOINT_DESKTOP,
  BREAKPOINT_MOBILE,
  BREAKPOINT_TABLET,
  SHINY_ANIMATED,
} from "constants/constants";
import { BREAKPOINT_DATERANGEPICKER_TWO_ROWS } from "./dateRangeUtils";

export const DateRangeContentStyles = styled.div<{
  $isDarkMode: boolean;
}>`
  position: relative;
  margin: auto;

  .date-range-btn,
  .react-datetimerange-picker__button {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border-radius: 4px;
    border: none !important;
    width: 16px;
    height: 16px;
    background: none !important;
    @media (min-width: ${BREAKPOINT_MOBILE}px) {
      width: 28px;
      height: 28px;
    }
    @media (min-width: ${BREAKPOINT_TABLET}px) {
      width: 28px;
      height: 28px;
    }
    @media (min-width: ${BREAKPOINT_DESKTOP}px) {
      width: 32px;
      height: 32px;
    }
    padding: 0;
    &:hover {
      background: ${lightBlueActive};
    }
    .MuiSvgIcon-root {
      fill: ${darkBlue};
    }
    text-transform: none;
    font-weight: bold;
    background: ${props =>
      props.$isDarkMode ? darkModeTitleBackgroundColor : darkNeutral10};
    color: ${props => (props.$isDarkMode ? darkModeTextColor : "black")};
    &.active {
      border: 1px solid ${brandPrimary70};
      background: ${lightBlueActive};
    }
  }
  .react-datetimerange-picker__range-divider {
    color: ${darkBlue};
    font-weight: bold;
    @media (max-width: ${BREAKPOINT_DATERANGEPICKER_TWO_ROWS}px) {
      margin-left: 3px;
      margin-right: 3px;
      transform: translateY(6px);
    }
  }

  .btn-clear-wrapper {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: fit-content;
    height: 100%;
  }
  .react-datetimerange-picker__clear-button,
  [aria-label="Submit"] .MuiButtonBase-root {
    align-self: center;
    &:hover {
      background: ${lightBlueActive};
    }
  }
  [aria-label="Submit"] {
  }
  &&& {
    .btnSubmit {
      transition: all 0.2s cubic-bezier(0.075, 0.82, 0.165, 1);
      box-sizing: content-box;
      padding: 6px;
      @media (min-width: ${BREAKPOINT_DESKTOP}px) {
        padding: 0px;
      }
      outline: 1px solid
        ${props => (props.$isDarkMode ? darkModeTitleBackgroundColor : "white")};
      &:not(.disabled) {
        outline: 1px solid ${brandPrimary70} !important;
        transform: scale(1.05) translateX(8px);
        background: ${lightBlueActive} !important;
        /* slow pulse scale-up animation that starts after a delay */
        ${SHINY_ANIMATED}
        &:after {
          pointer-events: none;
          animation: slidediagonal 2s infinite;
          animation-delay: 6s;
        }
      }
    }
  }
  @media (min-width: ${BREAKPOINT_TABLET}px) {
    .react-datetimerange-picker__clear-button {
    }
  }
  .MuiFormHelperText-root {
    max-width: 186px;
    height: 0;
    margin-bottom: 18px;
  }
  .MuiInputBase-root {
    cursor: pointer;
    width: 176px;
    input {
      padding: 0.5em 0 0.5em 0.5em;
    }
  }
  .future-calendar-tile {
    opacity: 0.5;
    pointer-events: none;
  }
  .offsetAndTimezoneIndicator {
    color: ${props => (props.$isDarkMode ? darkModeTextColor : lightTextBody)};
    position: absolute;
    bottom: -18px;
    left: 0px;
    font-size: 11px;
    height: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
